import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { BuildingType } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseMutationOptions<unknown, Error, { id: number }, BuildingType>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useDeleteBuildingTypeRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, { id: number }, BuildingType>(
    [Entities.BuildingTypes, 'delete'],
    async ({ id }) => {
      const { data } = await api.v1AdminBuildingTypesTypeIdDelete(id)
      return data
    },
    { ...options },
  )
}
